export const IMPORT_MEMBERS_VALIDATION_RULES = {
  clientId: {
    isRequiredTrim: {
      value: true,
    },
  },
  billingPeriodId: {
    isRequiredTrim: {
      value: true,
    },
  },
  fileFormat: {
    isRequiredTrim: {
      value: true,
    },
  },
  file: {
    isRequiredFile: {
      value: true,
    },
  },
  importSessionPeriod: {
    isRequiredTrim: {
      value: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/importExport/importMembers/importMembersValidationRules.js